/**
 * @author Milton Filho
 */
import { createAction } from 'redux-actions';
import {
  BOOKING_CONFLICTED,
  CLEAR_FAILED_ITEM,
  DISCARD_OFFLINE_BOOKING,
  ENQUEUE_OFFLINE_ITEM,
  OFFLINE_BOOK_APPOINTMENT_ENQUEUED,
  SYNC_BOOKING_SUCCESS,
  SYNC_COMPLETE,
  SYNC_ITEM_FAILURE,
  SYNC_ITEM_SUCCESS,
  SYNC_START,
} from './actionTypes';
import { OfflineQueueItem } from './types';
import { Appointment } from 'types/types';

export const enqueueOfflineItem =
  createAction<OfflineQueueItem>(ENQUEUE_OFFLINE_ITEM);

export const syncStart = createAction(SYNC_START);

export interface SyncItemSuccessPayload {
  queueItemId: string;
  pendingIdsToRemove: number[];
}
export const syncItemSuccess =
  createAction<SyncItemSuccessPayload>(SYNC_ITEM_SUCCESS);

export interface SyncBookingSuccessPayload {
  queueItemId: string;
  tempIds: number[];
  realAppointments: Appointment[];
}
export const syncBookingSuccess =
  createAction<SyncBookingSuccessPayload>(SYNC_BOOKING_SUCCESS);

export interface SyncItemFailurePayload {
  queueItemId: string;
  error: string;
}
export const syncItemFailure =
  createAction<SyncItemFailurePayload>(SYNC_ITEM_FAILURE);

export const syncComplete = createAction(SYNC_COMPLETE);

export interface ClearFailedItemPayload {
  queueItemId: string;
}
export const clearFailedItem =
  createAction<ClearFailedItemPayload>(CLEAR_FAILED_ITEM);

export interface OfflineBookAppointmentEnqueuedPayload {
  tempAppointments: Appointment[];
}
export const offlineBookAppointmentEnqueued =
  createAction<OfflineBookAppointmentEnqueuedPayload>(
    OFFLINE_BOOK_APPOINTMENT_ENQUEUED,
  );

export interface BookingConflictedPayload {
  queueItemId: string;
  tempAppointmentIds: number[];
  /** The slot the backend refused, as it was sent. */
  appDatetime: string;
  patientId: number;
  /**
   * Whether this item had already failed before the conflict, read at the
   *   moment the `409` arrived.
   *
   * This is the whole discriminator between the backend's two populations, so
   *   it is captured here rather than re-read later — by the time the resolver
   *   runs, the queue item may be gone.
   */
  hadFailedBefore: boolean;
}
export const bookingConflicted =
  createAction<BookingConflictedPayload>(BOOKING_CONFLICTED);

export interface DiscardOfflineBookingPayload {
  queueItemId: string;
  tempAppointmentIds: number[];
}
export const discardOfflineBooking = createAction<DiscardOfflineBookingPayload>(
  DISCARD_OFFLINE_BOOKING,
);
